import FoodChart from './FoodChart'
import FluidsChart from './FluidsChart.tsx'
import TurnsChart from './TurnsChart'
import WashChart from './WashChart'
import StoolChart from './StoolChart'
import LineChart from './LineChart'
import DailyChart from './DailyChart'
import MustScoreChart from './MustScoreChart'
import BloodOxygenChart from './BloodOxygenChart'
import BloodPressureChart from './BloodPressureChart'
import BloodGlucoseChart from './BloodGlucoseChart'
import HeartRateChart from './HeartRateChart'
import RespiratoryRateChart from './RespiratoryRateChart'
import MoodChart from './MoodChart'
import TemperatureChart from './TemperatureChart'
import WaterlowChart from './WaterlowChart'
import WeightChart from './WeightChart'
import DailyTotalChart from './DailyTotalChart'
import MobilityChart from './MobilityChart'
import ActivityChart from './ActivityChart'
import HealthVisitChart from './HealthVisitChart'
import IncidentsChart from './IncidentsChart'
import BehaviourChart from './BehaviourChart'
import PainChekChart from './PainChekChart'
import SeizureChart from './SeizureChart'

export const charts = {
  ActivityChart,
  BehaviourChart,
  BloodOxygenChart,
  BloodPressureChart,
  BloodGlucoseChart,
  DailyChart,
  DailyTotalChart,
  FluidsChart,
  FoodChart,
  HealthVisitChart,
  HeartRateChart,
  IncidentsChart,
  LineChart,
  MoodChart,
  MobilityChart,
  MustScoreChart,
  RespiratoryRateChart,
  StoolChart,
  TemperatureChart,
  TurnsChart,
  WaterlowChart,
  WeightChart,
  WashChart,
  PainChekChart,
  SeizureChart,
}

export default charts
